<template>
    <div class="wrap">
        <el-button type="primary" class="back_index" round @click="backIndex">返回主页</el-button>
        <div class="left">
            <img src="../../assets/img/logo.png" alt="" />
            <div class="text">
                <p>欢迎使用</p>
                <p>期货、期权交易虚拟仿真实验</p>
            </div>
        </div>
        <div class="right">
            <div class="back" v-show="isReg" @click="toReg(false)">
                <i class="el-icon-back"></i>
            </div>
            <div v-if="!isReg" class="ms-login">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="账号登录" name="0">
                        <el-form :model="loginForm" :rules="loginRules" ref="loginForm" style="margin-top: 20px">
                            <el-form-item label="用户名" prop="username">
                                <el-input v-model="loginForm.username" placeholder="请输入账号/学号"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" prop="password">
                                <el-input
                                    type="password"
                                    placeholder="密码由大写字母、小写字母、数字、特殊字符组成"
                                    v-model="loginForm.password"
                                    @keyup.enter.native="getSchool('loginForm')"
                                >
                                </el-input>
                            </el-form-item>
                            <el-button class="submit" type="primary" @click="getSchool('loginForm')">登录</el-button>
                        </el-form>
                    </el-tab-pane>

                    <!-- <el-tab-pane label="手机号/邮箱登录" name="1">
                        <el-form :model="phoneParam" :rules="phoneRules" ref="phoneParam" style="margin-top: 20px">
                            <el-form-item label="手机号/邮箱" prop="userphone">
                                <el-input v-model="phoneParam.userphone" placeholder="请输入手机号/邮箱"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" prop="phonePassword">
                                <el-input
                                    type="password"
                                    placeholder="请输入密码"
                                    v-model="phoneParam.phonePassword"
                                    @keyup.enter.native="getSchool('phoneParam')"
                                >
                                </el-input>
                            </el-form-item>
                            <el-button class="submit" type="primary" @click="getSchool('phoneParam')">登录</el-button>
                        </el-form>
                    </el-tab-pane> -->
                </el-tabs>
                <div class="links flex-between">
                    <div></div>
                    <!-- <el-button type="text" class="ques" @click="toReg(true)">前往注册</el-button> -->
                    <!-- <el-button type="text" class="forget" @click="forget">忘记密码？</el-button> -->
                </div>
            </div>
            <register v-else :isReg.sync="isReg" @updateInfo="updateInfo" @showDialog="showDialog"></register>
        </div>

        <!-- 选择角色 -->
        <el-dialog title="选择角色" :visible.sync="roleDialog" width="24%" center :close-on-click-modal="false">
            <div>
                <el-select v-model="roleId" placeholder="请选择角色">
                    <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.roleId"></el-option>
                </el-select>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancleRoleDia">取 消</el-button>
                <el-button v-if="activeName == '0'" type="primary" @click="roleSure('loginForm')">确 定</el-button>
                <el-button v-else type="primary" @click="roleSure('phoneParam')">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            :title="phoneReset ? '手机重置密码' : '邮箱重置密码'"
            :visible.sync="forgetVisible"
            :close-on-click-modal="false"
            @close="closeForget"
            width="30%"
        >
            <template v-if="phoneReset">
                <el-form ref="form" label-width="60px">
                    <el-form-item label="手机号">
                        <el-input placeholder="请输入手机号" v-model.number="phone" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码">
                        <div class="flex-between">
                            <el-input v-model.number="phoneCode" placeholder="请输入验证码" maxlength="6"></el-input>
                            <el-button style="margin-left: 10px" type="text" @click="sendPhoneCode" :disabled="phoneDisabled">{{
                                phoneBtnText
                            }}</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input type="password" placeholder="请输入新密码" v-model="newPassword"></el-input>
                    </el-form-item>
                </el-form>
                <div class="switch" @click="switchType(false)"><span>邮箱重置密码</span></div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="phoneVisible = false">取 消</el-button>
                    <el-button type="primary" @click="updatePassword(1)">确 定</el-button>
                </span>
            </template>
            <template v-else>
                <el-form ref="form" label-width="60px">
                    <el-form-item label="邮箱">
                        <el-input placeholder="请输入邮箱" v-model="email"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码">
                        <div class="flex-between">
                            <el-input v-model.number="emailCode" placeholder="请输入验证码" maxlength="6"></el-input>
                            <el-button style="margin-left: 10px" type="text" @click="sendEmailCode" :disabled="emailDisabled">{{
                                emailBtnText
                            }}</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input type="password" placeholder="请输入新密码" v-model="newPassword"></el-input>
                    </el-form-item>
                </el-form>
                <div class="switch" @click="switchType(true)"><span>手机重置密码</span></div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="emailVisible = false">取 消</el-button>
                    <el-button type="primary" @click="updatePassword">确 定</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="个人隐私协议" :visible.sync="privacyVisible" width="40%" center>
            <div v-html="privacyAgreement"></div>
        </el-dialog>
    </div>
</template>

<script>
import register from './RegisterForm';
export default {
    data: function () {
        return {
            activeName: '0',
            isReg: false,
            loginForm: {
                username: '',
                password: ''
            },
            loginRules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            phoneParam: {
                userphone: '',
                phonePassword: ''
            },
            phoneRules: {
                userphone: [{ required: true, message: '请输入手机号/邮箱', trigger: 'blur' }],
                phonePassword: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            roleDialog: false,
            userId: '',
            schoolId: '',
            roleId: '',
            roleList: [],
            studentId: '',
            forgetVisible: false,
            phoneReset: true,
            email: '',
            emailBtnText: '发送验证码',
            emailCode: '',
            emailDisabled: false,
            emailTimer: null,
            phone: '',
            phoneBtnText: '发送验证码',
            phoneCode: '',
            phoneDisabled: false,
            phoneTimer: null,
            newPassword: '',
            emailOpener: '',
            phoneOpener: '',
            urlData: '',
            type: '',
            loginId: '',
            status: '',
            privacyVisible: false,
            privacyAgreement: `<div &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以下隐私协议是本学校对用户隐私保护的许诺，请您务必仔细阅读本协议，以了解我们关于管理您个人信息的情况。本隐私协议的全部条款属于本软件用户服务协议的重要部份之一。<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了给您提供更准确、更有针对性的服务，本软件可能会以如下方式，使用您提交的个人信息。但本软件会以高度的勤勉义务对待这些信息，在未征得您许可的情况下，不会将这些信息对外公开或向第三方提供。</p>\n<p>一、保有您提供的信息</p>\n<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本软件会在您自愿选择服务或提供信息的情况下收集您的个人信息，并将这些信息进行整合，以便向您提供更好的用户服务。请您在注册时及时、详尽及准确的提供个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，由您自行承担相应的后果。请您不要将您的帐号、密码转让或出借予他人使用。如您发现您的帐号遭他人非法使用，应立即通知本软件。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，本软件不承担责任。</p>\n<p>二、保有您的使用记录</p>\n<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当您使用本软件的服务时，服务器会自动记录一些信息，包括手机型号、IP地址等。</p>\n<p>        在如下情况下，本软件会遵照您的意愿或法律的规定披露您的个人信息，由此引发的问题将由您个人承担：<br />\n（1）事先获得您的授权；<br />\n（2）只有透露你的个人资料，才能提供你所要求的产品和服务；<br />\n（3）根据有关的法律法规要求；<br />\n（4）按照相关政府主管部门的要求；<br />\n（5）为维护本软件的合法权益。<br />\n（6）您同意让第三方共享资料。<br />\n（7）我们发现您违反了本软件的服务条款或使用规定。<br />\n（8）我们需要向代表我们提供产品或服务的学校提供资料（除非我们另行通知你，否则这些学校无权使用你的身份识别资料）。</p>\n<p>三、本《隐私政策》不适用于以下情况：</p>\n<p>（1）通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息。本政策仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任；</p>\n<p>（2）通过在我们服务中进行广告服务的其他学校或机构所收集的信息。</p>\n<p>四、隐私权政策的修订</p>\n<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们可能适时修订本政策的条款，修订政策也是构成本政策的一部分。如修订政策造成您在本政策下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本政策的约束。</p>\n<p>五、用户如何更正或投诉个人信息</p>\n<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如果您需要查询、修改或更正您的个人信息，或对个人信息保护问题有任何疑问或建议，您可以通过服务支持邮箱msdw@maxsdsp.com联系我们。</p>\n<p>著作权归本学校所有。商业转载请联系作者获得授权，非商业转载请注明出处。</p>\n`,
            accountName: '',
            token: ''
        };
    },
    components: {
        register
    },
    mounted() {
        this.autoLogin();
        this.$once('hook:beforeDestroy', function () {
            clearInterval(this.phoneTimer);
            this.phoneTimer = null;
            clearInterval(this.emailTimer);
            this.emailTimer = null;
        });
    },
    methods: {
        //显示用户协议
        showDialog(data) {
            this.privacyVisible = data.isShow;
        },
        //根据type判断是否为校内登录，校内登录自动登录
        //type为0为校外登录，1为校内登录,2为ilab登录
        //loginId为4是学生账号，为14是教师
        // https://vlab.uestc.edu.cn/finance/kdclient/#/clientLogin?type=1&account=2020070903015&roleId=4&status=200&token=e4b3090e-2649-4cec-8545-2472465fa086&userId=2063
        autoLogin() {
            this.$route.query.account && (this.loginForm.username = this.$route.query.account);
            this.$route.query.type && (this.type = this.$route.query.type);
            this.$route.query.roleId && (this.loginId = this.$route.query.roleId);
            this.$route.query.status && (this.status = this.$route.query.status);
            this.schoolId = 2105; // 电子科大学校id
            this.$route.query.roleId && (this.roleId = this.$route.query.roleId);
            this.$route.query.userId && (this.userId = this.$route.query.userId);
            this.$route.query.token && (this.token = this.$route.query.token);
            this.$route.query.pass && (this.loginForm.password = this.$route.query.pass);
            // 学生账号
            if ((this.type == '1' || this.type == '2') && this.loginId == '4') {
                this.$store.commit('tokenData', { loginToken: this.token });
                this.submitForm();
                return;
            }
            // 教师账号
            if (this.type == '1' && this.loginId == '14') {
                // this.$router.push('/login');
                // let url = `${this.$config.baseUrl}/kdserver/#/?type=1&account=${this.loginForm.username}&status=${this.status}&redirect=true`;
                let url = `${this.$config.baseUrl}/kdserver/#/?type=1&account=${this.loginForm.username}&pass=${this.loginForm.password}&status=${this.status}&redirect1=true`
                window.open(url, '_blank');
            }
        },
        backIndex() {
            this.$router.push('login');
        },
        getSchool(form) {
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let data = {
                        account: this.activeName == '0' ? this.loginForm.username : this.phoneParam.userphone,
                        password: this.activeName == '0' ? this.loginForm.password : this.phoneParam.phonePassword,
                        schoolId: 2105,
                        source: this.activeName
                    };
                    this.$post(this.api.loginSchool, data)
                        .then((res) => {
                            if (res.status == 200) {
                                this.schoolList = [...res.message.staffList, ...res.message.studentList];
                                let indexs = {};
                                this.schoolList = this.schoolList.reduce((cur, next) => {
                                    indexs[next.schoolId] ? '' : (indexs[next.schoolId] = true && cur.push(next));
                                    return cur;
                                }, []);
                                if (this.schoolList.length >= 1) {
                                    this.schoolId = this.schoolList[0].schoolId;
                                    this.userId = this.schoolList[0].userId;
                                    this.studentId = this.schoolList[0].studentId;
                                    // this.getRole()
                                    this.roleId = 4;
                                    this.$store.commit('tokenData', { loginToken: res.message.loginToken });
                                    this.submitForm(form);
                                } else {
                                    this.$message.error('账号不存在');
                                }
                            } else {
                                this.$message.error(res.errmessage);
                            }
                        })
                        .catch((res) => {});
                } else {
                    this.$message.error('请输入账号和密码');
                    return false;
                }
            });
        },
        getRole(form) {
            let data = {
                userId: this.userId,
                schoolId: this.schoolId
            };
            this.$post(this.api.loginRole, data)
                .then((res) => {
                    this.roleList = [...res.message.staffList, ...res.message.studentList];
                    let indexs = {};
                    this.roleList = this.roleList.reduce((cur, next) => {
                        indexs[next.roleId] ? '' : (indexs[next.roleId] = true && cur.push(next));
                        return cur;
                    }, []);
                    this.roleList.forEach((n, k) => {
                        switch (n.roleId) {
                            case 2:
                                n.roleName = '管理员';
                                break;
                            case 3:
                                n.roleName = '老师';
                                break;
                            case 4:
                                n.roleName = '学生';
                                break;
                        }
                    });
                    if (this.roleList.length > 1) {
                        this.roleDialog = true;
                    } else {
                        this.roleId = this.roleList[0].roleId;
                        this.submitForm(form);
                    }
                })
                .catch((res) => {});
        },
        updateInfo(data) {
            this.loginForm.username = data.username;
            this.loginForm.password = data.password;
        },
        roleSure(form) {
            if (this.roleId) {
                this.submitForm(form);
            } else {
                this.$message.error('请选择角色！');
            }
        },
        submitForm() {
            let data = {
                roleId: this.roleId,
                userId: this.userId,
                schoolId: this.schoolId
            };
            this.$get(this.api.logins, data)
                .then((res) => {
                    this.$post(this.api.updateLogInNumber, { userId: this.userId })
                        .then((res) => {})
                        .catch((res) => {});
                    this.$message.success('登录成功');
                    sessionStorage.setItem(
                        'kd_client_username',
                        this.activeName == '0' ? this.loginForm.username : this.phoneParam.userphone
                    );
                    this.$store.commit('userLoginData', {
                        userId: this.userId,
                        accountRole: this.roleId,
                        studentId: this.studentId,
                        schoolId: this.schoolId,
                        token: res.message.user.token
                    });
                    res.message.user.userAvatars && this.$store.commit('userPhoto', { avatar: res.message.user.userAvatars });
                    this.$store.commit('userName', { userName: res.message.user.userName });
                    this.$store.commit('dataTime', { dataTime: res.message.user.dataTime });
                    sessionStorage.setItem('isTeacher', false);
                    if (this.type == '2') {
                        sessionStorage.setItem('isTeacher', true);
                    }
                    let redirect = decodeURIComponent(this.$route.query.redirect || '/dashboard');
                    this.$router.replace(redirect);
                })
                .catch((res) => {});
        },
        cancleRoleDia() {
            this.roleId = '';
            this.roleDialog = false;
        },
        toReg(status) {
            this.isReg = status;
        },
        forget() {
            this.forgetVisible = true;
        },
        emailCountdown() {
            let count = 60;
            if (!this.emailTimer) {
                this.emailDisabled = true;
                this.emailTimer = setInterval(() => {
                    if (count > 0) {
                        count--;
                        this.emailBtnText = `${count}秒后重试`;
                    } else {
                        this.emailDisabled = false;
                        clearInterval(this.emailTimer);
                        this.emailTimer = null;
                        this.emailBtnText = `发送验证码`;
                    }
                }, 1000);
            }
        },
        phoneCountdown() {
            let count = 60;
            if (!this.phoneTimer) {
                this.phoneDisabled = true;
                this.phoneTimer = setInterval(() => {
                    if (count > 0) {
                        count--;
                        this.phoneBtnText = `${count}秒后重试`;
                    } else {
                        this.phoneDisabled = false;
                        clearInterval(this.phoneTimer);
                        this.phoneTimer = null;
                        this.phoneBtnText = `发送验证码`;
                    }
                }, 1000);
            }
        },
        closeForget() {
            this.phoneCode = '';
            this.emailCode = '';
            this.userId = '';
            this.newPassword = '';
        },
        sendEmailCode() {
            if (!this.email) return this.$message.warning('请输入邮箱');
            if (!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(this.email))
                return this.$message.warning('请输入正确的邮箱');
            let data = {
                email: this.email
            };
            this.$get(this.api.findPasswordByEmail, data)
                .then((res) => {
                    if (res.errmessage == 'success') {
                        this.$message.success('发送成功');
                        this.emailCountdown();
                        this.userId = res.data.userId;
                        this.emailOpener = res.data.opener;
                    }
                })
                .catch((res) => {});
        },
        sendPhoneCode() {
            if (!this.phone) return this.$message.warning('请输入手机号');
            if (!/^1[3456789]\d{9}$/.test(this.phone)) return this.$message.warning('请输入正确的手机号');
            let data = {
                phone: this.phone
            };
            this.$get(this.api.findPasswordByPhone, data)
                .then((res) => {
                    if (res.errmessage == 'success') {
                        this.$message.success('发送成功');
                        this.phoneCountdown();
                        this.userId = res.data.userId;
                        this.phoneOpener = res.data.opener;
                    }
                })
                .catch((res) => {});
        },
        async updatePassword(type) {
            if (type == 1) {
                if (!this.phone) return this.$message.warning('请输入手机号');
                if (!/^1[3456789]\d{9}$/.test(this.phone)) return this.$message.warning('请输入正确的手机号');
                if (!this.phoneCode) return this.$message.warning('请输入验证码');
            } else {
                if (!this.email) return this.$message.warning('请输入邮箱');
                if (!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(this.email))
                    return this.$message.warning('请输入正确的邮箱');
                if (!this.emailCode) return this.$message.warning('请输入验证码');
            }
            if (!this.newPassword) return this.$message.warning('请输入新密码');

            let checkData = {
                code: type == 1 ? this.phoneCode : this.emailCode,
                opener: type == 1 ? this.phoneOpener : this.emailOpener
            };
            let checkRes = await this.$post(this.api.checkCode, checkData);
            if (checkRes.errmessage == 'success') {
                let resetData = {
                    userId: this.userId,
                    password: this.newPassword
                };
                let resetRes = await this.$post(this.api.resetPassword, resetData);
                if (resetRes.errmessage == 'success') {
                    this.$message.success('重置成功');
                    this.forgetVisible = false;
                }
            }
        },
        switchType(type) {
            this.phoneReset = type;
        }
    }
};
</script>

<style scoped lang="scss">
.wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background: url(../../assets/img/login_bg.png) 0 0/100% 100% no-repeat;
    overflow: hidden;

    .logo {
        position: absolute;
        top: 20px;
        left: 72px;
        width: 240px;
    }
    .left {
        position: absolute;
        top: 50%;
        left: 221px;
        transform: translateY(-60%);

        img {
            width: 447px;
            margin-bottom: 30px;
        }
        .text {
            font-size: 47px;
            color: #fff;
            p {
                margin-bottom: 15px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
    .right {
        position: absolute;
        top: 50%;
        right: 100px;
        transform: translateY(-50%);
        width: 700px;
        padding: 50px 90px 20px;
        background-color: #fff;
        box-sizing: border-box;
        box-shadow: 0 1px 20px rgba(0, 0, 0, 0.16);

        .back {
            position: absolute;
            top: 20px;
            left: 20px;
            font-size: 24px;
            color: #105cb2;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }
        }

        h2 {
            padding-bottom: 10px;
            font-size: 24px;
            font-weight: 400;
            color: #303d4c;
            text-align: center;
            border-bottom: 1px solid #e5e5e5;
        }
        /deep/.el-form {
            margin-top: 30px;

            .label {
                margin-bottom: 10px;
                color: #105cb2;
            }
            /deep/.el-input__inner {
                height: 46px;
                padding: 0 23px;
                line-height: 46px;
                border: 1px solid #afb5bb;
                border-radius: 23px !important;
            }
            /deep/.el-form-item__error {
                top: 105%;
                left: auto;
                right: 0;
                color: #ffa94e;
            }
            .submit {
                width: 100%;
                height: 48px;
                margin-top: 60px;
                line-height: 48px;
                padding: 0;
                font-size: 20px;
                background-color: #105cb2;
                border-radius: 23px;
                border: 0;
            }
            .login-tips {
                margin-bottom: 20px;
                font-size: 16px;
                color: #105cb2;
                text-align: center;
            }
            .thirdParty {
                .item {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 20px;
                    padding: 10px 0;
                    color: #afb5bb;
                    font-size: 16px;
                    background-color: #eff0f1;
                    border-radius: 36px;
                    cursor: pointer;
                    img {
                        width: 40px;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
.switch {
    span {
        cursor: pointer;
        color: #9076ff;
    }
}
.links {
    margin: 20px 0 20px;
}
.ques {
    color: #105cb2;
    font-size: 14px;
}
.forget {
    color: #ffa94e;
    font-size: 14px;
}
.back_index {
    position: fixed;
    width: 150px;
    height: 60px;
    // z-index: 200;
    bottom: 80px;
    right: 100px;
}
</style>
